import { faCheck, faEdit, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionalMenu } from '@molecules/functionalMenu';

export const ActionsMenu = ({
    doCreate,
    doEdit,
    doSave,
    doCancel,
    doDelete,
}: {
    doCreate?: () => void;
    doEdit?: () => void;
    doSave?: () => void;
    doCancel?: () => void;
    doDelete?: () => void;
}) => {
    const menuItems = [];

    if (doCreate) {
        menuItems.push({
            key: 'createElement',
            label: 'Создать',
            icon: <FontAwesomeIcon icon={faPlus} />,
            onClick: doCreate,
        });
    }

    if (doEdit) {
        menuItems.push({
            key: 'edit',
            label: 'Редактировать',
            icon: <FontAwesomeIcon icon={faEdit} />,
            onClick: doEdit,
        });
    }

    if (doSave) {
        menuItems.push({
            key: 'save',
            label: 'Сохранить',
            icon: <FontAwesomeIcon icon={faCheck} />,
            onClick: doSave,
        });
    }

    if (doCancel) {
        menuItems.push({
            key: 'abort',
            label: 'Отмена',
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: doCancel,
        });
    }
    if (doDelete) {
        menuItems.push({
            key: 'delete',
            label: 'Удалить',
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: doDelete,
        });
    }

    return <FunctionalMenu items={menuItems} dropdownItems={[]} />;
};
